import { subscriptionsWithIndex } from "app/pages/sales-intelligence/modules/signals-api-webhook/utils/subscriptionsWithIndex";

import createEmptySubscription from "../factories/createEmptySubscription";
import type { IWebhookSubscriptionTableBaseModel, IWebhookSubscriptionTableModel } from "../types/row-data";

function subscriptionsValueTransformer(
    subscriptions: readonly IWebhookSubscriptionTableBaseModel[],
): IWebhookSubscriptionTableModel[] {
    if (subscriptions.length) {
        return subscriptionsWithIndex(subscriptions);
    }

    return subscriptionsWithIndex([createEmptySubscription()]);
}

export default subscriptionsValueTransformer;
